import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "text-center py-6"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("br", null, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_VerseMenu = _resolveComponent("VerseMenu")!
  const _component_ManuscriptOverview = _resolveComponent("ManuscriptOverview")!
  const _component_RemoteContent = _resolveComponent("RemoteContent")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_CatalogueEntry = _resolveComponent("CatalogueEntry")!
  const _component_HowToQuote = _resolveComponent("HowToQuote")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_VerseMenu),
    _createVNode(_component_RemoteContent, { data: _ctx.manuscriptDetail }, {
      default: _withCtx(() => [
        (_ctx.isLoaded(_ctx.manuscriptDetail))
          ? (_openBlock(), _createBlock(_component_ManuscriptOverview, {
              key: 0,
              manuscript: _ctx.manuscriptDetail.payload,
              class: "my-6"
            }, null, 8, ["manuscript"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["data"]),
    (_ctx.isLoaded(_ctx.manuscriptDetail) && _ctx.$route.name === 'ManuscriptSingle')
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("h3", null, [
            _createTextVNode(_toDisplayString(_ctx.$t('manuscripts.no_page_selected')), 1),
            _hoisted_2,
            _createTextVNode(" " + _toDisplayString(_ctx.$t('manuscripts.no_page_selected_instructions')), 1)
          ])
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_router_view),
    (_ctx.isLoaded(_ctx.manuscriptDetail))
      ? (_openBlock(), _createBlock(_component_CatalogueEntry, {
          key: 1,
          manuscript: _ctx.manuscriptDetail.payload,
          class: "my-6"
        }, null, 8, ["manuscript"]))
      : _createCommentVNode("", true),
    (_ctx.isLoaded(_ctx.manuscriptWeb))
      ? (_openBlock(), _createBlock(_component_HowToQuote, {
          key: 2,
          citation: _ctx.manuscriptWeb.payload.how_to_cite
        }, null, 8, ["citation"]))
      : _createCommentVNode("", true)
  ], 64))
}